/**
 * Validaciones de los acompañantes (idx > 0) de Black Summit.
 * El huésped principal (idx === 0) sigue usando getCheckInPersonSchema.
 *
 * Solo se piden nombre, apellido, fecha de nacimiento y nacionalidad;
 * el resto de los campos queda oculto en el formulario y sin validación.
 */
export const blackSummitCompanionFieldsConfig = {
    name: {
        validations: {
            string: true,
            allow_null: true,
            'minimal-letters': 2,
            'maximal-letters': 50,
            required: true,
        }
    },
    surname: {
        validations: {
            string: true,
            allow_null: true,
            'minimal-letters': 2,
            'maximal-letters': 50,
            required: true,
        }
    },
    birthday: {
        validations: {
            date: true,
            allow_null: true,
            'max-date-now': true,
            typeError: '-',
            required: true,
        }
    },
    nationality: {
        validations: {
            string: true,
            allow_null: true,
            'minimal-letters': 2,
            required: true,
        }
    },

    // Campos ocultos para el acompañante: se declaran para dejar explícito que no se validan
    dni: {
        validations: {
            string: true,
            allow_null: true,
        }
    },
    dniType: {
        validations: {
            string: true,
            allow_null: true,
        }
    },
    dniIssueDate: {
        validations: {
            date: true,
            allow_null: true,
            typeError: '-',
        }
    },
    gender: {
        validations: {
            string: true,
            allow_null: true,
        }
    },
    address: {
        validations: {
            string: true,
            allow_null: true,
        }
    },
    zipCode: {
        validations: {
            string: true,
            allow_null: true,
        }
    },
    residence: {
        validations: {
            string: true,
            allow_null: true,
        }
    },
    city: {
        validations: {
            string: true,
            allow_null: true,
        }
    },
    photos: {
        selfie: {
            validations: {
                string: true,
                allow_null: true,
            }
        },
        dniFront: {
            validations: {
                string: true,
                allow_null: true,
            }
        },
        dniBack: {
            validations: {
                string: true,
                allow_null: true,
            }
        }
    },
    age: {
        validations: {
            number: true,
            allow_null: true,
            'maximal-digits': 120,
        }
    }
}
